import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apolloApi } from "@/shared/api";

export function ClearPlayerCache() {
  const navigate = useNavigate();

  useEffect(() => {
    apolloApi.clearPlayerCache();

    navigate("/");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
